/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Packing_List_NumberInputs */

const en_inbound_field_packing_list_number = /** @type {(inputs: Inbound_Field_Packing_List_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packing list number`)
};

/**
* | output |
* | --- |
* | "Packing list number" |
*
* @param {Inbound_Field_Packing_List_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_packing_list_number = /** @type {((inputs?: Inbound_Field_Packing_List_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Packing_List_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_packing_list_number(inputs)
});